export default {
  authenticated: () => import("/builds/nht4944308/brands/umarketpro/webapp/layouts/authenticated.vue").then(m => m.default || m),
  default: () => import("/builds/nht4944308/brands/umarketpro/webapp/layouts/default.vue").then(m => m.default || m),
  error: () => import("/builds/nht4944308/brands/umarketpro/webapp/layouts/error.vue").then(m => m.default || m),
  unauthenticated: () => import("/builds/nht4944308/brands/umarketpro/webapp/layouts/unauthenticated.vue").then(m => m.default || m)
}